import WidgetSettingsSymbolEditor, {
    WidgetSymbolEditorProps,
} from 'widgets/WidgetSettingsEditing/WidgetSettingsSymbolEditor';
import React from 'react';
import { useTileContext } from 'widgets/tiles/components/tile/TileContext';

export interface CapsuleSettingsSymbolEditorProps
    extends WidgetSymbolEditorProps {
    group?: boolean;
}

export function CapsuleSettingsSymbolEditor(
    props: CapsuleSettingsSymbolEditorProps
) {
    const { group } = props;
    const { disableSymbolConfig } = useTileContext();

    if (disableSymbolConfig) {
        return <></>;
    }

    if (group) {
        return (
            <div className="group">
                <WidgetSettingsSymbolEditor {...props} />
            </div>
        );
    }

    return <WidgetSettingsSymbolEditor {...props} />;
}
